/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-var-requires */
import Alpine from 'alpinejs'
Alpine.start()

import $ = require('jquery');
(<any>window).jQuery = $;
// @ts-ignore
import { initContactForm } from './contact-form';
import { initCookieConsent } from './cookie-consent';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import '@fancyapps/fancybox/dist/jquery.fancybox';
import 'slick-carousel';
import { initPageListSplide } from './pageListSplide';
import {initBannerBlockSplide} from './bannerBlockSplide';
import { initHeader } from './header';
import { initFaqBlock } from './faqBlock';
import { initPuffBlock } from './puffBlock';




// @ts-ignore
var mixitup = require('mixitup');
var mixitupMultifilter = require('../wwwroot/js/mixitup-multifilter.js');

// @ts-ignore
import flatpickr from "flatpickr";

mixitup.use(mixitupMultifilter);



$(document).ready(() => {
    initHeader();
    initContactForm();
    initCookieConsent();

    var today = new Date();
    var tomorrow = new Date(today).setDate(today.getDate() + 1);

    const departure = flatpickr("#departure", {
        defaultDate: tomorrow,
        dateFormat: "Y-m-d",
        locale: Swedish
    });

    flatpickr("#arrival", {
        defaultDate: today,
        dateFormat: "Y-m-d",
        locale: Swedish,
        onChange: function (d: any) {
            const date = new Date(d[0]);
            date.setDate(date.getDate() + 1);
            departure.setDate(date);
        }
    });

    setupCarousel();
    setupTabs();

    if ($('.pagelist-block').length > 0) {
        initPageListSplide();
    }
    if ($('.banner-block').length > 0) {
        initBannerBlockSplide();
    }
    if ($('.faq-block').length > 0) {
        initFaqBlock();
    }
    if ($('.puff-block').length > 0) {
        initPuffBlock();
    }

    $('.navigation-toggle').click(function () {
        toggleNavigation()
    });

    $('.close-navigation').click(function () {
        toggleNavigation()
    });

    $('.navigation-subitem-button').click(function (e) {
        var menuItem: string = e.target.attributes.getNamedItem('value').value;
        console.log(e.target);
        console.log(menuItem);
        toggleNavigationSubitems(menuItem);
    });

    $('.navigation-subsubitem-button').click(function (e) {
        e.stopPropagation(); // viktigt!
        const menuItem = $(this).attr('value');
        toggleNavigationSubSubitems(menuItem);
    });

    var filterContainer = $(".filter-container")[0];
    var contactFilterContainer = $(".contact-filter-container")[0];
    var eventFilterContainer = $(".event-filter-container")[0];
    var activityFilterContainer = $(".activity-filter-container")[0];


    if ($(".popular").length) {
        if (filterContainer != undefined) {
            var mixer = mixitup(filterContainer, {
                multifilter: {
                    enable: true // enable the multifilter extension for the mixer
                },
                load: {
                    filter: '.popular'
                }
            });
        }
    }

    if ($(".populart").length) {
        if (filterContainer != undefined) {
            var mixer = mixitup(filterContainer, {
                multifilter: {
                    enable: true // enable the multifilter extension for the mixer
                },
                load: {
                    filter: '.populart'
                }
            });
        }
    }

    if (contactFilterContainer != undefined) {

        if ($(".bokning").length) {
            var mixer = mixitup(contactFilterContainer, {
                load: {
                    filter: '.bokning'
                }
            });
        }
        else {
            var mixer = mixitup(contactFilterContainer);
        }


    }

    if (eventFilterContainer != undefined) {
        var mixer = mixitup(eventFilterContainer, {

        });
    }

    if (activityFilterContainer != undefined) {
        var mixer = mixitup(activityFilterContainer, {

        });
    }

    $(document).on('click', '.play-pause-button', function () {
        const $button = $(this);
        const $block = $button.closest('.block');
        const video = $block.find('video').get(0) as HTMLVideoElement;

        if (!video) return;

        $button.toggleClass('active');

        if (video.paused) {
            video.play().catch(() => {});
        } else {
            video.pause();
        }
    });



});


function toggleNavigation() {
    if ($('.responsive-navigation').hasClass('active')) {
        $('.responsive-navigation').removeClass('active');
        document.body.style.overflow = '';
    }
    else {
        $('.responsive-navigation').addClass('active');
        document.body.style.overflow = 'hidden'; 
    }
}

function toggleNavigationSubitems(menuItem: string) {
    if ($('.subitem-' + menuItem).hasClass('active')) {
        $('.subitem-' + menuItem).css('display', 'none');
        $('.subitem-' + menuItem).removeClass('active');
        /*$('.svg-' + menuItem).removeClass('active');*/
    } else {
        $('.subitem-' + menuItem).addClass('active');
        $('.subitem-' + menuItem).css('display', 'block');
        $('.svg-' + menuItem).addClass('active');
    }
}

function toggleNavigationSubSubitems(menuItem: string) {
    const el = $('.subsubitem-' + menuItem);

    if (el.hasClass('active')) {
        el.removeClass('active').hide();
        $('.svg-subsub-' + menuItem).removeClass('active');
    } else {
        el.addClass('active').show();
        $('.svg-subsub-' + menuItem).addClass('active');
    }
}

function setupTabs() {
    $('.tab').click(function () {
        $('.tab').removeClass('active');
        $('.tab-content').removeClass('active');
        var id = $(this).attr('data-tab-id');
        $('[data-tab-id=' + id + ']').addClass('active').delay(200).queue(function () {

        });
    });
}

function setupCarousel() {
    $('.carousel').slick(
        {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            mobileFirst: true,
            arrows: true,
            pauseOnHover: false,
            adaptiveHeight: true
        }
    );
}
// const textontext = document.querySelectorAll('.text-on-text');
// if (textontext) {
//     textontext.forEach(el => {
//         const mirror = document.createElement('span');
//         mirror.textContent = el.textContent;
//         mirror.classList.add('mirror');
//         el.appendChild(mirror);
//     });
// }

const textontext = document.querySelectorAll('.text-on-text');

if (textontext) {
    textontext.forEach(el => {
        const wrapper = document.createElement('span');
        wrapper.classList.add('mirror-wrapper');

        const mirror = document.createElement('span');
        mirror.textContent = el.textContent;
        mirror.classList.add('mirror');

        wrapper.appendChild(mirror);
        el.appendChild(wrapper);
    });
}
